import { cn, useThemeStore } from "@theprelude/core";
import { Button, MoonIcon, SunIcon } from "@theprelude/ds";
import { tb } from "@/lib/tracking";

export function ThemeSwitcher() {
  const theme = useThemeStore((state) => state.theme);
  const setTheme = useThemeStore((state) => state.setTheme);

  return (
    <Button
      intent="pill"
      onClick={() => setTheme(theme === "light" ? "dark" : "light")}
      className={cn("relative gap-1", tb("theme-switch"))}
    >
      <div
        className={cn(
          "absolute h-4 w-4 translate-x-5 transform rounded-full bg-secondary-foreground transition-transform",
          theme === "light" && "translate-x-0 transform",
        )}
      />
      <SunIcon className="size-4 text-secondary-foreground" />
      <MoonIcon className="size-4 text-secondary-foreground" />
    </Button>
  );
}
